import { ConditionalLink } from "components/conditionalLink";
import { Button } from "components/DesignSystem/Button/Button";
import { LargeCard } from "components/home/Home";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import React from "react";
import AssistedIncorporationBG from "static/images/AssistedIncorporationBG.svg";
import { useGetTaskListForUserQuery } from "store/apis/taskList";
import {
  US_HOLDCO_INCORPORATION,
  US_SUBSIDARY_INCORPORATION,
} from "types/Models/services";

const baseTaskKeys = [US_HOLDCO_INCORPORATION, US_SUBSIDARY_INCORPORATION];

export const AssistedIncorporation = () => {
  const { isCustomer } = useRoleBasedView();
  const { data, isLoading, isSuccess } = useGetTaskListForUserQuery(
    {
      taskCategoryType: "TAX,RND",
      baseTaskKey: baseTaskKeys.join(","),
    },
    { skip: !isCustomer, refetchOnMountOrArgChange: true }
  );

  if (isLoading || !isSuccess || !data?.tasks || data?.tasks?.length === 0) {
    return null;
  }

  const task = data?.tasks?.[0];

  if (!task) {
    return null;
  }

  return (
    <LargeCard>
      <ConditionalLink to="/tax/others/incorporation">
        <div className="t-p-6 t-rounded-lg t-border t-border-solid t-border-neutral-10 t-relative t-flex t-flex-col t-justify-between t-h-[200px]">
          <div>
            <div className="t-text-subtitle-lg t-text-text-100">
              Assisted Incorporation
            </div>
            <div className="t-text-body-sm t-text-text-30 t-mt-1.5">
              Track and manage your incorporation progress effortlessly.
            </div>
          </div>
          <div>
            <Button customType="primary" size="small">
              Go to Incorporation
            </Button>
          </div>
          <img
            src={AssistedIncorporationBG}
            alt="AssistedIncorporationBG"
            className="t-absolute t-right-0 t-bottom-0"
          />
        </div>
      </ConditionalLink>
    </LargeCard>
  );
};
